import { motion } from "framer-motion";

export default function Marquee() {
  const items = [
    "OWN YOUR PIPELINE",
    "OWN YOUR PIPELINE",
    "OWN YOUR PIPELINE",
    "OWN YOUR PIPELINE",
  ];
  return (
    <section
      aria-label="Marquee"
      className="relative overflow-hidden border-y wam-hairline py-16 md:py-24"
      data-testid="marquee-section"
    >
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 40, ease: "linear", repeat: Infinity }}
      >
        {[...items, ...items].map((t, i) => (
          <span
            key={i}
            className="mx-6 font-display"
            style={{
              fontSize: "clamp(52px, 10vw, 148px)",
              lineHeight: 1,
              letterSpacing: "-0.045em",
              color: "transparent",
              WebkitTextStroke: "1px rgba(240,236,228,0.28)",
            }}
          >
            {t}
            <span className="mx-6 text-[#C9A84C]" style={{ WebkitTextStroke: 0 }}>
              ·
            </span>
          </span>
        ))}
      </motion.div>
    </section>
  );
}
